"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalAnnualHomePaymentChoiceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("react-datepicker/src/stylesheets/datepicker.scss");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var plugin_support_1 = require("@falcon/plugin-support");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../../commonFunctions");
var SupportPortalAnnualHomePaymentChoiceWidget = /** @class */ (function (_super) {
    __extends(SupportPortalAnnualHomePaymentChoiceWidget, _super);
    function SupportPortalAnnualHomePaymentChoiceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = function (event) {
            if (event.target.value === "fullPrice") {
                _this.setPayFullPrice(true);
            }
            else if (event.target.value === "partOfPrice") {
                _this.setPayFullPrice(false);
            }
        };
        _this.state = {
            payFullPrice: undefined,
            remainingAmountPresent: false,
            dataLoaded: false,
        };
        return _this;
    }
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.componentDidMount = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        this.supportPortalService.getCombinedInstalmentsInfoByPartyReference(interaction.userReference)
            .subscribe(function (instalmentsInfo) {
            if (instalmentsInfo) {
                var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) !== 0;
                _this.setState({
                    remainingAmountPresent: remainingAmountPresent,
                    dataLoaded: true
                });
            }
        });
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.render = function () {
        var additionalPremium = this.props.interaction.factors.additionalPremium;
        return ((0, jsx_runtime_1.jsxs)("div", { children: [this.getPaymentText(), this.getPaymentButtons(additionalPremium)] }));
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.setPayFullPrice = function (value) {
        this.props.onStateChange("uistate.payFullPrice", value);
        journey_services_1.ObjectManipulator.setField("uistate.payFullPrice", this.props.interaction, value);
        this.setState({ payFullPrice: value });
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.getPaymentText = function () {
        return (0, jsx_runtime_1.jsx)("h1", { className: "text-blue-2", children: "How'd you like to pay?" });
    };
    SupportPortalAnnualHomePaymentChoiceWidget.prototype.getPaymentButtons = function (additionalPremium) {
        var manyPaymentChoice = this.state.remainingAmountPresent ? "d-flex" : "text-center";
        if (this.state.dataLoaded) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "w-100", children: (0, jsx_runtime_1.jsxs)("div", { className: "payment-choice ".concat(manyPaymentChoice), children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio w-50 mx-0 pr-2", children: [(0, jsx_runtime_1.jsx)("input", { id: "yearly", className: "custom-control-input", type: "radio", name: "payment", value: "fullPrice", onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsxs)("label", { className: "custom-control-label h-100 p-2", htmlFor: "yearly", children: [this.state.payFullPrice === true
                                            ? (0, jsx_runtime_1.jsx)("img", { className: "radio-circle", alt: "full selected", src: "/img/radio-circle-selected.svg" })
                                            : (0, jsx_runtime_1.jsx)("img", { className: "radio-circle", alt: "full", src: "/img/radio-circle.svg" }), (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-semi-bold pt-3", children: ["Pay ", (0, commonFunctions_1.getAmountToDisplay)(additionalPremium), " now by card"] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { className: "visa-icon-small", alt: "visa-icon", src: "/img/visa-icon.svg" }), (0, jsx_runtime_1.jsx)("img", { className: "mastercard-icon-small", alt: "mastercard-icon", src: "/img/mastercard-icon.svg" })] })] })] }), this.state.remainingAmountPresent && (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio w-50 mx-0 pl-2", children: [(0, jsx_runtime_1.jsx)("input", { id: "monthly", className: "custom-control-input", type: "radio", name: "payment", value: "partOfPrice", onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsxs)("label", { className: "custom-control-label h-100 p-2", htmlFor: "monthly", children: [this.state.payFullPrice === false
                                            ? (0, jsx_runtime_1.jsx)("img", { className: "radio-circle", alt: "monthly selected", src: "/img/radio-circle-selected.svg" })
                                            : (0, jsx_runtime_1.jsx)("img", { className: "radio-circle", alt: "monthly", src: "/img/radio-circle.svg" }), (0, jsx_runtime_1.jsx)("p", { className: "font-weight-semi-bold pt-3", children: "Continue with your direct debit payment plan" })] })] })] }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_support_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], SupportPortalAnnualHomePaymentChoiceWidget.prototype, "supportPortalService", void 0);
    return SupportPortalAnnualHomePaymentChoiceWidget;
}(plugin_journey_1.WidgetBase));
exports.SupportPortalAnnualHomePaymentChoiceWidget = SupportPortalAnnualHomePaymentChoiceWidget;
//# sourceMappingURL=SupportPortalAnnualHomePaymentChoiceWidget.js.map